import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ContactModal from './ContactModal';
// import { EnvelopeIcon } from '@heroicons/react/24/outline';
// import { FaWhatsapp } from 'react-icons/fa';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const menuRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/home" || location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/home");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openContactModal = () => {
    setIsModalOpen(true);
    setMenuOpen(false);
  };

  return (
    <>
      {/* Fixed Header */}
      <header className="fixed left-0 w-full z-50 bg-transparent backdrop-blur-sm shadow-md py-4 px-6 flex items-center justify-between">
        <div className="text-white text-xl font-lato font-semibold">
          <img
            src="/images/dimensi-sinergi-bw.png"
            alt="Dimensi Sinergi Logo"
            onClick={handleLogoClick}
            className="h-8 md:h-10 cursor-pointer"
          />
        </div>
        <div
          className="text-white text-4xl cursor-pointer"
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </div>
      </header>

      {/* Slide-Out Menu */}
      <div
        ref={menuRef}
        className={`fixed top-0 right-0 h-screen w-1/2 bg-white z-50 transform transition-transform duration-300 ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex h-full flex-col md:flex-row">
          {/* Background image – show only on desktop */}
          <div
            className="w-full sm:w-1/2 md:w-1/2 bg-cover bg-center sm:h-auto sm:block md:h-auto hidden md:block"
            style={{ backgroundImage: "url('/images/Asset/Photo-menu.png')" }}
          ></div>

          {/* Vertical color bar */}
          <div className="w-full md:w-[4px] flex md:flex-col">
            <div className="h-[26%] bg-red-500 md:w-full md:h-[26%]" />
            <div className="h-[74%] bg-blue-900 md:w-full md:h-[74%]" />
          </div>

          {/* Menu content with adaptive vertical position */}
          <div className="w-full md:w-1/2 p-6 sm:px-6 sm:py-4 md:px-6 md:py-2 flex flex-col h-full text-black font-lato overflow-y-auto">
            <button
              className="self-end text-3xl mb-4 hover:text-red-500"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              ✕
            </button>

            {/* Main Navigation List */}
            <nav className="flex flex-col flex-grow justify-start mt-2 sm:mt-0 md:mt-0 lg:mt-6">
              <ul className="space-y-6 sm:space-y-5 md:space-y-6 lg:space-y-12 text-xl sm:text-2xl md:text-2xl lg:text-4xl font-lato tracking-wide ml-2">
                {["About Us", "Projects", "Services", "FAQ"].map((label, idx) => {
                  const path = `/${label.toLowerCase().replace(/\s+/g, "")}`;
                  const isActive = location.pathname === path;
                  return (
                    <li key={idx}>
                      <Link
                        to={path}
                        className={`block relative w-fit transition-colors duration-300
                          ${
                            isActive
                              ? "text-blue-800 font-semibold"
                              : "text-black hover:text-blue-700"
                          }
                          after:absolute after:left-0 after:bottom-0 after:h-[2px]
                          ${
                            isActive
                              ? "after:w-full" : "after:w-0 hover:after:w-full"
                          } after:bg-blue-700 after:transition-all after:duration-300`}
                        onClick={() => setMenuOpen(false)}
                      >
                        {label}
                      </Link>
                    </li>
                  );
                })}
                <li>
                  <button
                    onClick={openContactModal}
                    className="block relative w-fit left-0 text-black hover:text-blue-700 transition-colors duration-300 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 hover:after:w-full after:bg-blue-700 after:transition-all after:duration-300"
                  >
                    Contact Us
                  </button>
                </li>
              </ul>

              {/* Enhanced white space content - now part of the flex column, pushing down */}
              <div className="flex flex-col items-center flex-grow justify-end pb-4 pt-4">
                {/* Short Slogan/Tagline */}
                {/* <p className="text-xs sm:text-sm md:text-base lg:text-base text-gray-700 text-center mb-6 px-4 md:mb-8 max-w-xs leading-snug">
                  Your Trusted Partner for Reliable Electrical Solutions.
                </p> */}

                {/* Social Media/Contact Buttons */}
                {/* <div className="flex flex-row justify-center gap-4 mb-8 w-full px-2 flex-wrap">
                    <a
                      href="https://wa.me/628122914419"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="min-w-[60px] max-w-[110px] flex items-end justify-center gap-1 bg-green-500 hover:bg-green-700 font-lato font-semibold text-white px-3 py-2 text-xs rounded-lg shadow-md transition-all duration-300" // Reduced padding, text size
                    >
                      <FaWhatsapp className="text-sm" />
                      WhatsApp
                    </a>
                    <a
                      href="mailto:Dimensi.sinergi95@gmail.com"
                      className="min-w-[60px] max-w-[110px] flex items-end justify-center gap-1 bg-blue-700 hover:bg-blue-900 font-lato font-semibold text-white px-3 py-2 text-xs rounded-lg shadow-md transition-all duration-300" // Reduced padding, text size
                    >
                      <EnvelopeIcon className="h-4 w-4" />
                      Email
                    </a>
                </div> */}

                {/* Logo at the bottom of the menu */}
                <Link
                  to="/home"
                  onClick={() => { setMenuOpen(false); handleLogoClick(); }}
                  className="mt-auto block cursor-pointer"
                >
                  <img
                    src="/images/dimensi-sinergi.png"
                    alt="Dimensi Sinergi Logo - Home"
                    className="h-6 md:h-6 lg:h-8 opacity-80 hover:opacity-100 transition-opacity duration-300"
                  />
                </Link>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {/* Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}